import StarRating from 'src/components/StarRating'
import CustomerReviewsVersionB from 'src/components/restructure/product/sections/CustomerReviews/CustomerReviewsVersionB'

import type { Product } from '../../../../../types/product'
import type { ProductItem } from '../../../../../types/productItem'
import type { Review } from '../../../../../types/review'

type MiniPdpReviewsContentProps = {
  currentSku: ProductItem
  product: Product
  rating: Review | null
}

type MiniPdpReviewsTitleProps = {
  reviewAverageNote: number
}

export const MiniPdpReviewsTitle = ({
  reviewAverageNote,
}: MiniPdpReviewsTitleProps) => {
  return (
    <span className="flex items-center gap-2 text-font-size-7 font-medium">
      Avaliações
      <span className="flex items-center gap-1.5">
        <StarRating
          rating={reviewAverageNote}
          maxStars={5}
          width={11}
          height={11}
          color="#101010"
        />
        <span className="text-sm">{reviewAverageNote.toFixed(1)}</span>
      </span>
    </span>
  )
}

export const MiniPdpReviewsContent = ({
  currentSku,
  product,
  rating,
}: MiniPdpReviewsContentProps) => {
  return (
    <CustomerReviewsVersionB
      currentSku={currentSku}
      product={product}
      rating={rating}
    />
  )
}
